var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatusIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3293 13.3812C21.6297 13.3812 21.0113 13.832 20.7956 14.4976C19.6293 18.1004 16.2476 20.7144 12.2612 20.7144C7.3121 20.7144 3.28552 16.6874 3.28552 11.738C3.28552 7.7679 5.87794 4.39705 9.45861 3.21752C10.15 2.98972 10.6184 2.34329 10.6184 1.61452C10.6184 1.09831 10.3714 0.613042 9.95431 0.30949C9.53719 0.00547315 8.99972 -0.0803217 8.50888 0.0777214C3.57831 1.66562 0 6.28698 0 11.7381C0 18.4995 5.50015 24 12.2611 24C17.6905 24 22.2963 20.4498 23.9014 15.5505C24.0665 15.0467 23.9799 14.4945 23.6687 14.0651C23.3583 13.6359 22.8602 13.3812 22.3293 13.3812Z",
    fill: "#00609B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0188 3.20317C17.7444 4.08551 19.9011 6.23751 20.7899 8.9602C21.0113 9.63799 21.6426 10.0957 22.3557 10.0957H22.3895C22.9044 10.0957 23.3882 9.84946 23.6913 9.43353C23.9938 9.01763 24.0803 8.48139 23.9224 7.99135C22.7201 4.25271 19.7692 1.29568 16.0336 0.0845499C15.5387 -0.0758143 14.9957 0.0103604 14.5746 0.316318C14.1535 0.622698 13.9041 1.11206 13.9041 1.63291V1.66865C13.9039 2.36733 14.3546 2.98777 15.0188 3.20317Z",
    fill: "#00609B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusIcon);
export default __webpack_public_path__ + "static/media/StatusIcon.106ca85c498427ae3cf7ff452dd3a127.svg";
export { ForwardRef as ReactComponent };